 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","1":"default~app-messaging-messaging-chat-groupchat-management-modal-groupchat-management-modal-module-ng~4dc34410","2":"default~app-financial-operations-payments-deposit-payments-modal-payments-modal-module-ngfactory~app~d9725f28","3":"default~app-messaging-messaging-chat-call-alert-modal-call-alert-modal-module-ngfactory~app-messagin~1236372f","4":"default~app-financial-operations-payments-deposit-payments-modal-payments-modal-module-ngfactory~app~4b0af72f","5":"default~app-financial-operations-payments-deposit-payments-modal-payments-modal-module-ngfactory~app~022fe366","6":"default~app-financial-operations-payments-deposit-payments-modal-payments-modal-module-ngfactory~app~dc0975d4","7":"default~app-projects-project-view-expanded-bid-overlay-expanded-bid-overlay-module-ngfactory~app-ref~3798740c","8":"default~app-projects-project-view-expanded-bid-overlay-expanded-bid-overlay-module-ngfactory~app-ref~3731926e","9":"default~app-messaging-messaging-chat-groupchat-management-modal-groupchat-management-modal-module-ng~539a9558","10":"default~app-tasks-tasks-module-ngfactory~app-tutorial-home-tutorial-modal-tutorial-modal-module-ngfa~9e071639","12":"default~app-referrals-give-get-modal-give-get-modal-module-ngfactory~compat-compat-messaging-module-~5937fdee","13":"default~app-tasks-tasks-module-ngfactory~compat-compat-tasklist-module-ngfactory","14":"default~app-projects-project-view-expanded-bid-overlay-expanded-bid-overlay-module-ngfactory~app-ref~a144186d","18":"app-messaging-messaging-chat-confirm-modal-confirm-modal-module-ngfactory","19":"app-projects-hireme-modal-hireme-modal-module-ngfactory","20":"app-projects-request-milestone-modal-request-milestone-modal-module-ngfactory","21":"app-projects-create-milestone-modal-create-milestone-modal-module-ngfactory","22":"app-projects-create-milestone-upgrade-modal-create-milestone-upgrade-modal-module-ngfactory","23":"app-projects-award-modal-award-modal-module-ngfactory","24":"app-messaging-messaging-chat-call-alert-modal-call-alert-modal-module-ngfactory","25":"app-messaging-messaging-chat-groupchat-management-modal-groupchat-management-modal-module-ngfactory","26":"app-financial-operations-payments-deposit-payments-modal-payments-modal-module-ngfactory","27":"app-projects-delete-modal-delete-modal-module-ngfactory","28":"app-projects-project-view-project-view-overlay-modal-project-view-overlay-modal-module-ngfactory","29":"app-tasks-tasks-module-ngfactory","30":"app-tutorial-home-tutorial-modal-tutorial-modal-module-ngfactory","31":"app-projects-milestone-confirm-modal-milestone-confirm-modal-module-ngfactory","32":"app-academy-instructor-dashboard-page-confirm-publish-course-modal-confirm-publish-course-modal-module-ngfactory","33":"app-academy-instructor-dashboard-page-confirm-unpublish-course-modal-confirm-unpublish-course-modal-module-ngfactory","34":"app-academy-instructor-dashboard-page-confirm-close-course-modal-confirm-close-course-modal-module-ngfactory","35":"app-academy-instructor-dashboard-page-confirm-delete-course-modal-confirm-delete-course-modal-module-ngfactory","36":"app-projects-milestone-cancel-modal-milestone-cancel-modal-module-ngfactory","37":"app-projects-project-view-expanded-bid-overlay-expanded-bid-overlay-module-ngfactory","38":"app-referrals-give-get-modal-give-get-modal-module-ngfactory","39":"freelancer-tracking-tracking-module-ngfactory","40":"compat-compat-navigation-module-ngfactory","41":"compat-compat-navigation-empty-module-ngfactory","42":"app-navigation-navigation-secondary-navigation-secondary-projects-module-ngfactory","43":"app-navigation-navigation-secondary-navigation-secondary-about-module-ngfactory","44":"app-navigation-navigation-secondary-navigation-secondary-contests-module-ngfactory","45":"app-navigation-navigation-secondary-navigation-secondary-community-module-ngfactory","46":"app-navigation-navigation-secondary-navigation-secondary-profile-module-ngfactory","47":"app-navigation-navigation-secondary-navigation-secondary-showcase-module-ngfactory","48":"app-navigation-navigation-secondary-navigation-secondary-local-jobs-module-ngfactory","49":"app-navigation-navigation-secondary-navigation-secondary-finances-module-ngfactory","50":"app-navigation-navigation-secondary-navigation-secondary-my-skills-module-ngfactory","51":"app-navigation-navigation-secondary-navigation-secondary-hire-freelancers-module-ngfactory","52":"app-navigation-navigation-secondary-navigation-secondary-help-module-ngfactory","53":"compat-compat-messaging-module-ngfactory","54":"compat-compat-modals-module-ngfactory","55":"compat-compat-abtest-module-ngfactory","56":"compat-compat-tasklist-module-ngfactory"}[chunkId]||chunkId) + "." + {"0":"e11bb013b29a2b93f61d","1":"964fea1d22869aaf5d82","2":"0730bc19a2c927236c9e","3":"68b0656b468e174b30af","4":"a5a74b49d3227a7e3f06","5":"a7255a77afdbc26dad45","6":"bfa4dce8aa4153ad7d3e","7":"f6f08c117e001762ea70","8":"7aead8bdeb9d8af10d6a","9":"640e698e0086061d9ef4","10":"2e1f125c77aed9098460","12":"09356b91d4709d8fddfa","13":"29d7b972e8c233b114af","14":"9809feaafcccc0ffcea6","18":"928d6ab7b90090cb0012","19":"83ebf0dae197bbdc894d","20":"9e5882f50bc1b8461054","21":"341524b0c5b50255493b","22":"c8cb11e5fba34ff20995","23":"e6424bad0c494e06c3b3","24":"148e929ea12559d2b021","25":"cce638abec4dd8c855a4","26":"88253ea2c3747ad28e57","27":"36b121d4af26bc93d49a","28":"af3175a59c81d668ff11","29":"a4a5dd301ff0ee695c69","30":"aa7d67c910fa680dbdf6","31":"505adccb480bdaa267bc","32":"6d369e34db78d86eef96","33":"54d9597d772f9e3be50b","34":"86db7416f99546d8b9f4","35":"6624cec1f4cedf7f6696","36":"75f737bcc9de5efe7731","37":"5988257cb7925b1336fa","38":"7a13d8e97d7addbcb587","39":"4f4db6b45a943dba4e44","40":"98db1cf06828bfb56c3e","41":"0e573cb11c5e2001c8a4","42":"d0f3a61f2bb2f9a1143b","43":"55eef589ae225ce8c2cd","44":"c9450dc7e8b065d4531f","45":"6b0d5acc486246c4246b","46":"10d73eda76722abab8c3","47":"cfb7ae1db17b75014936","48":"3f857c5419fda514dea0","49":"7a628188af226b660328","50":"cbfefd8778420f95c39a","51":"5fe0c072cbc84a28a0bd","52":"767765b05bd0311b1c05","53":"2bd7d11fcdfaf3c1f2bb","54":"e60341ad77df8115bc2a","55":"7bbef82d35b7f448cb84","56":"9af55f916f5f8738c15c","57":"cb2ae97ab1c71b7baac8","58":"11b3c7858c0afdd6ef6d","59":"0e588a03f9246cd19b76","60":"f3f84277b1870bfb3e21","61":"a556ebbd6a0f181d4f53","62":"1bbe5c19e875a82874e4","63":"225a205e17c0fa6ba428","64":"56cad25a7122a2529ce0","65":"bf5f0a0ae7a92b555806","66":"e417e66af0e4a0f4c721","67":"e518cfc9e5fbbfccfbca","68":"0df76ff0fa2f593eb513","69":"d1522dbb436c47858c72","70":"059db7911c582d19a322","71":"3b19cf271c657c717aed","72":"eceb5bfc8820379d0c18","73":"9ac5287fafbcf3019597","74":"72bb9c1f9e2db2071d08","75":"1ab64905db3794863939","76":"a39f30025afa6c610061","77":"0c6df87703a4f7a5abf5","78":"4eb34f71203e594aa86e","79":"24230fabedfc4daebc5e","80":"85485448f155989746b5","81":"fefb4e341563f562af46","82":"f10b4b30da7687c3c9ce"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.f-cdn.com/assets/vi/webapp-compat/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
